import { storableError } from 'util/errors';
import validatePrivateListingPasscode from '../api';
import { setValidatedPasscode } from '../utils/passcode';

const initialState = {
  isWaitingForPasscode: false,
  validating: false,
  valid: false,
  validateError: null,
};

const INIT_PASSCODE_VALIDATION_STATE = 'app/promoCode/INIT_PASSCODE_VALIDATION_STATE';
const VALIDATE_PASSCODE_REQUEST = 'app/promoCode/VALIDATE_PASSCODE_REQUEST';
const VALIDATE_PASSCODE_SUCCESS = 'app/promoCode/VALIDATE_PASSCODE_SUCCESS';
const VALIDATE_PASSCODE_ERROR = 'app/promoCode/VALIDATE_PASSCODE_ERROR';

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INIT_PASSCODE_VALIDATION_STATE: {
      return {
        ...initialState,
        isWaitingForPasscode: true,
      };
    }
    case VALIDATE_PASSCODE_REQUEST:
      return { ...state, validating: true, valid: false, validateError: null };
    case VALIDATE_PASSCODE_SUCCESS:
      return {
        ...state,
        validating: false,
        valid: payload.valid,
        isWaitingForPasscode: false,
        currentListingId: null,
        validateSuccessCallback: null,
        validateError: null,
      };
    case VALIDATE_PASSCODE_ERROR:
      return { ...state, validating: false, valid: false, validateError: payload };
    default:
      return state;
  }
}

export const initPasscodeValidationState = () => ({
  type: INIT_PASSCODE_VALIDATION_STATE,
});

const validateRequest = () => ({ type: VALIDATE_PASSCODE_REQUEST });
const validateSuccess = (valid) => ({ type: VALIDATE_PASSCODE_SUCCESS, payload: { valid } });
const validateError = (e) => ({ type: VALIDATE_PASSCODE_ERROR, payload: e });

export const validatePassCode =
  ({ passcode, listingId }) =>
  async (dispatch) => {
    dispatch(validateRequest());

    try {
      const { data: isValid } = await validatePrivateListingPasscode({
        passcode,
        id: listingId,
      });

      // Store the passcode in session storage if validation is successful
      if (isValid && listingId) {
        setValidatedPasscode(listingId, passcode);
      }

      dispatch(validateSuccess({ valid: isValid }));
      return isValid;
    } catch (e) {
      const error = storableError(e);
      dispatch(validateError(error));
      return false;
    }
  };

export const selectIsPasscodeValid = (state) => state.privateListings.valid;
export const selectIsValidatingPasscode = (state) => state.privateListings.validating;
export const selectPassCodeValidateError = (state) => state.privateListings.validateError;
export const selectIsWaitingForPasscode = (state) => state.privateListings.isWaitingForPasscode;
